import axiosInstance from './axiosInstance'; 

const API_URL = 'https://idealonline.com.tr/service/idealonline/v1/';

export const updatauthorstemplatesandattributedata = async (id,status,data, token) => {
    const response = await axiosInstance.post(`authorstemplatesandattributedata/update/${id}/${status}`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  };
  
  export const updatauthorstemplatesandattributedatafullDelete = async (id, token) => {
    try {
      const response = await axiosInstance.get(
        `authorstemplatesandattributedata/fullDelete/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error deleting author template and attribute data:", error);
      throw error; 
    }
  };
  
    
  export const creatauthorstemplatesandattributedata = async (id,data, token) => {
    const response = await axiosInstance.post(`authorstemplatesandattributedata/create/${id}`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  };
    
  export const updateStatusauthorstemplatesandattributedata = async (id,status, token) => {
    const response = await axiosInstance.get(`authorstemplatesandattributedata/updateStatus/${id}/${status}`,  {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  };
    
  export const getauthorstemplatesandattributedata = async (id,status, token) => {
    const response = await axiosInstance.get(`authorstemplatesandattributedata/ListByAuthorId/${id}/${status}`,  {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  };

    export const getauthorstemplatesandattributedatasearch = async (id,status, token) => {
    const response = await axiosInstance.get(`authorstemplatesandattributedata/search/ListByAuthorId/${id}/${status}`,  {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  };
    
  export const authorsElasticJSONFullList = async (token) => {
    const response = await axiosInstance.get(`authorstemplatesandattributedata/authorsElasticJSONFullList`,  {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  };
  

  export const ListByAuthorIdAndTemplateId = async (authorid,templateid,status, token) => {
    try {
      const response = await axiosInstance.get(`authorstemplatesandattributedata/ListByAuthorIdAndTemplateId/${authorid}/${templateid}/${status}`, {
        //params: { page, size },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching authors list:", error);
      throw error;
    }
  };